import { setData } from "rivals/shared/utils/qa";

function FacebookVideo({ videoUrl }: { videoUrl: string }): JSX.Element {
  return (
    <iframe
      allowFullScreen
      allowTransparency
      height="340"
      src={`https://www.facebook.com/plugins/video.php?href=${videoUrl}&amp;show_text=0`}
      style={{ border: "none", maxWidth: "100%", overflow: "hidden" }}
      title={`facebook-video-embed-${videoUrl}`}
      {...setData("facebook-video-embed", videoUrl)}
    />
  );
}

export default FacebookVideo;
